<style lang="scss" scoped>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}
.info {
  position: relative;
  padding: 5px;
  background: white;
  text-align: center;
}
</style>

<template>
    <div class="bookmark-component">
        <div class="bookmark-container">
            <div v-if="isCareTeam">
              <div class="info">
                <div class="card-content" >
                  <img style="background:#fff;border-radius:50px;display:block;margin:0 auto;width:50px;height:50px;padding:10px" src="@/assets/care-teams.jpg"/>
                </div>
                <p v-if="info_item.data" v-html="info_item.data.tip"></p>
              </div>
              <transition-group name="mfade">
                <!-- <div v-if="isLoadingCareteamGroup" key="loading">
                  <p align="center" style="padding:10px"><i class="fa fa-spin fa-spinner" /> Loading Care Teams... </p>
                </div> -->
                <div v-if="!isLoadingCareteamGroup && careteamgroups <= 0" key="empty">
                  <p align="center" style="padding:10px"> Empty </p>
                </div>
                <div v-else-if="!isLoadingCareteamGroup" class="bookmark-body" v-for="(bookmark, indx) in careteamgroups" :key="indx">
                  <!-- <pre>{{brandInfo}}</pre> -->
                  <FeedListView 
                    :avatar="getDisplayImage(bookmark)"
                    :title="bookmark.careplan.title"
                    :item="bookmark.careplan"
                    :isCare="true"
                    @emitContainer="onRedirectUser(bookmark.careplan)"></FeedListView>
                </div>
              </transition-group>
            </div>
            <div v-else>
              <div class="info">
                <div class="card-content" >
                  <img style="background:#fff;border-radius:50px;display:block;margin:0 auto;width:50px;height:50px;padding:10px" src="@/assets/icons8-bookmark-filled-50.png"/>
                </div>
                <p v-if="info_item.data" v-html="info_item.data.tip"></p>
              </div>
              <span style="display: flex;height: 70vh;align-items: center;justify-content: center;" v-if="userBookmarks.data.length == 0"> No bookmarks yet </span>
              <div class="bookmark-body" v-for="(bookmark, indx) in userBookmarks.data" :key="indx">
                  <div v-if="bookmark.type == 'careplan_item' && bookmark.data">
                      <div v-if="bookmark.data.type == 'directory'">
                          <FeedListView :avatar="'directory'"
                              :title="bookmark.data.title"
                              :sub-info="bookmark.rrule_parsed_date"
                              :item="bookmark.data"
                              @emitContainer="onRedirect(bookmark)"></FeedListView>
                      </div>

                      <div v-if="bookmark.data.type != 'directory'">
                          <FeedListView :avatar="bookmark.data.cover_photo || getImageFromTip(bookmark.data.data.tip)"
                              :title="bookmark.data.title"
                              :sub-info="bookmark.rrule_parsed_date"
                              :poster="bookmark.data.careplan ? bookmark.data.careplan.title : bookmark.data.title"
                              :item="bookmark.data"
                              @emitContainer="onRedirect(bookmark)"></FeedListView>
                      </div>
                  </div>

                  <div v-if="bookmark.type == 'person' && bookmark.data">
                      <FeedListView :avatar="bookmark.data.avatar"
                          :title="bookmark.data.display_name"
                          :sub-info="bookmark.rrule_parsed_date"
                          :item="bookmark.data"
                          @emitContainer="onRedirect(bookmark)"></FeedListView>
                  </div>

                  <div v-if="bookmark.type == 'brand' && bookmark.data">
                      <FeedListView :avatar="bookmark.data.avatar"
                          :title="bookmark.data.display_name"
                          :item="bookmark.data"
                          @emitContainer="onRedirect(bookmark)"></FeedListView>
                  </div>
              </div>
            </div>
        </div>
        <Spin style="margin: 20px 0;" v-if="isLoadingLoadMore">
            <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
    </div>
</template>

<script>
import FeedListView from '@/components/FeedListView'
import { log } from 'util';
import { mapGetters } from 'vuex';
import _ from 'lodash'

export default {
  name: 'BookmarkComopnent',
  components: {
    FeedListView
  },
  data() {
    return {
      info_item: ''
    }
  },
  computed: {
    brandInfo: {
      get () {
        return this.$store.state.user.brand
      }
    },
    ...mapGetters("user", [
      "userInfo",
      "careteamgroupsitem",
      "isLoadingCareteamGroup"
    ]),
    journal() {
      return this.$store.state.user.info
    },
    userBookmarks: {
      get () {
        return this.$store.state.user.userBookmarks
      }
    },
    isLoadingLoadMore: {
      get () {
        return this.$store.state.user.isLoadingLoadMore
      }
    },
    isCareTeam() {
      return (this.$route.query.careteam && this.$route.query.careteam == "1") ? true : false
    },
    careteamCurrentUser() {
      return {
        prescriber: {
          avatar: this.journal.avatar
        },
        careplan : {
          developed_by: this.journal.id,
          title: this.journal.display_name
        },
        accepted_user: {
          avatar : this.journal.avatar
        }
      }
    },
    careteamgroups() {
      var res = this.careteamgroupsitem.careplans

      var index = _.findIndex(res,(o) => {
        return o.accepted_user.id == this.userInfo.id && o.prescriber.id == this.userInfo.id
      }) 
      
      if (index == -1){
        res.splice(0, 0, this.careteamCurrentUser)
      }
      else {
        res.splice(0, 0, res.splice(index, 1)[0])
      }
      return res
    }
  },
  mounted() {
    if( this.isCareTeam )
      this.loadCareTeamGroups();

    this.getActivityInfo()
  },
  methods: {
    getImageFromTip(html) {
      let parsed = new DOMParser().parseFromString(html, "text/html")
      return parsed.images.length > 0 ? parsed.images[0].src : ''
    },
    getDisplayImage(data) {
      if (data.accepted_user.id !== this.userInfo.id){
        return data.accepted_user.avatar
      }
      else if (data.prescriber.id !== this.userInfo.id){
        return data.prescriber.avatar
      }
      else {
        return data.accepted_user.avatar
      }
    },
    getActivityInfo() {
      this.$store.dispatch('user/getActivityInfo', Cons[0].GROUP_ID[this.isCareTeam ? 'myCareTeamsId' : 'myBookmarksId'][process.env.VUE_APP_DEV_STATUS])
        .then(res => {
          this.info_item = res
        })
    },
    loadCareTeamGroups() {
      this.$store.dispatch('user/getUserCareTeamGroups', this.journal.journal_id);
    },
    onRedirectUser(item) {
      if (this.journal.id == item.developed_by)
        this.$router.push({ path: '/' + process.env.VUE_APP_DEV_ECOSYSTEM + '/profile/' + item.developed_by, query: { tab: "team" } })
      else
        this.$router.push({ path: '/' + process.env.VUE_APP_DEV_ECOSYSTEM + '/profile/' + item.developed_by, query: { tab: "me" } })
    },
    onRedirect (data) {
      if (data.type == 'careplan_item') {
        if (data.data.type != 'directory') {
          this.$router.push({ path: '/feed/' + data.data.id })
        } else {
          this.$router.push({
            path:
              '/directory?slug=' +
              data.data.data.directory_type_slug +
              '&filter=' +
              data.data.data.category_slug
          })
        }
      } else if (data.type == 'person') {
        this.$router.push({ path: '/profile/' + data.data.id })
      }
       else if (data.type == 'brand') {
        this.$router.push({ path: '/organization/' + data.data.careplan_id })
      }
    }
  }
}
</script>
